const toggleMenuClass = (toggle) => {
  document.body.classList.toggle('is-open-menu', toggle);
  toggleBodyScrollLock(toggle);

  if (toggle === false) {
    // Close all open submenu
    const openSubmenu = document.querySelectorAll('.has-sub.is-open-submenu');
    const openItemsParent = document.querySelectorAll('.menu__step-body.show-line');
    const allItems = [...openSubmenu, ...openItemsParent];
    allItems.forEach((item) => {
      item.classList.remove('is-open-submenu', 'show-line');
    });
  }
};

// ------
// Mobile menu toggle
// ------

attachEvent('.header-main__hamburger, .mobile-hamburger', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
  ev.preventDefault();
});

// Close menu on click of overlay
attachEvent('.menu__overlay', 'click', () => {
  toggleMenuClass(false);
});

// ------
// Add class to body after some scroll
// ------
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 20);
}

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
const addClassOnScroll = () => {
  const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
  document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
  lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
};

window.addEventListener(
  'scroll',
  () => {
    addClassOnScroll();
  },
  false,
);

addClassOnScroll();

// ------
// Set top header height
// ------

const headerTop = document.querySelector('.header-main__top');

if (headerTop) {
  const getHeaderTopHeight = () => {
    document.documentElement.style.setProperty('--header-top-height', `${headerTop.clientHeight}px`);
  };
  const debounceGetHeaderTopHeight = debounce(getHeaderTopHeight, 100);
  window.addEventListener('DOMContentLoaded', debounceGetHeaderTopHeight);
  window.addEventListener('resize', debounceGetHeaderTopHeight);
}
